import {
  brandMarkSource,
  brandMarkSourceSet,
  brandMarkWebpSourceSet,
} from "./brand-mark-assets.js";

export function BrandMark({ className, sizes = "56px" }: { className?: string; sizes?: string }) {
  return (
    <picture className="zy-brand-picture">
      <source type="image/webp" srcSet={brandMarkWebpSourceSet} sizes={sizes} />
      <img
        className={["zy-brand-mark", className].filter(Boolean).join(" ")}
        src={brandMarkSource}
        srcSet={brandMarkSourceSet}
        sizes={sizes}
        width="512"
        height="512"
        alt=""
        aria-hidden="true"
      />
    </picture>
  );
}
